import { STATUS, calcularCursadasAprobadasCPC, calcularPuntosCPO, calcularCursadasAprobadasCPONegritas } from './careerLogic';

export function buildCycleContext(materias) {
  const cpcCount = calcularCursadasAprobadasCPC(materias);
  const cbcOk = Object.values(materias).filter(
    (m) => m.categoria === 'CBC' && (
      m.estado === STATUS.CURSADA_APROBADA || m.notaFinal === -3
    )
  ).length === 6;
  const cpoPts = calcularPuntosCPO(materias, '').total;
  return {
    cbcOk,
    cpc10Ok: cpcCount >= 10,
    cpc11Ok: cpcCount >= 11,
    cpc12Ok: cpcCount >= 12,
    cpc14Ok: cpcCount >= 14,
    cpcCount,
    cpoPts,
    negritasAprobadasOCursadas: calcularCursadasAprobadasCPONegritas(materias),
  };
}

export function getApplicableCycleFlags(materia) {
  if (!materia?.categoria) return [];
  if (materia.categoria === 'CPC') return ['CBC'];
  if (String(materia.categoria).startsWith('CPO')) {
    const isNegrita = ['uba_21','uba_22','uba_23','uba_24','uba_25'].includes(materia.id);
    return isNegrita ? ['CPC10'] : ['CPC12'];
  }
  if (materia.id === 'cpo_idioma_lectocomprension') return ['CPC14','CPO3NEGRITAS'];
  if (materia.id === 'cpo_practica_profesional') return ['CPC14','CPO5NEGRITAS','CPO20PTS'];
  return [];
}

export function getDirectCorrelativas(materia, materias) {
  if (!materia?.correlativas?.length) return [];
  return materia.correlativas
    .map((id) => materias[id])
    .filter(Boolean)
    .map((m) => ({
      id: m.id,
      nombre: m.nombre,
      cumplida: (m.estado === STATUS.CURSADA_APROBADA),
    }));
}

export function getDirectUnlocks(selectedId, plan) {
  const result = [];
  for (const g of (plan.grupos || [])) {
    for (const m of (g.materias || [])) {
      if (Array.isArray(m.correlativas) && m.correlativas.includes(selectedId)) {
        result.push({ id: m.id, nombre: m.nombre });
      }
    }
  }
  return result;
}

export function getFlagStatus(flag, ctx) {
  switch (flag) {
    case 'CBC': return ctx.cbcOk;
    case 'CPC10': return ctx.cpc10Ok;
    case 'CPC11': return ctx.cpc11Ok;
    case 'CPC12': return ctx.cpc12Ok;
    case 'CPC14': return ctx.cpc14Ok;
    case 'CPO3NEGRITAS': return (ctx.negritasAprobadasOCursadas >= 3);
    case 'CPO5NEGRITAS': return (ctx.negritasAprobadasOCursadas >= 5);
    case 'CPO20PTS': return (ctx.cpoPts >= 20);
    default: return false;
  }
}


